import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { GlobalErrorService } from '@services/global-error.service';
import { ValidateProfilePayload, ValidateProfileResponse } from '../../pages/vendor/add-candidate/add-candidate.model';

@Injectable({ providedIn: 'root' })
export class ProfileValidationService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient, private errorHandler: GlobalErrorService) {}

  validateProfile(payload: ValidateProfilePayload): Observable<ValidateProfileResponse> {
    const url = `${this.baseUrl}/vendor/contractor/validate_profile`;
    return this.http.post<ValidateProfileResponse>(url, payload).pipe(
      catchError((error) => this.errorHandler.logError(error))
    );
  }
}
